export class TarjetaCreditoConst {
  public static headerTable = [
    { field: 'accountNumber', title: 'Cuenta contable', cell: (row) => row.accountNumber ? `${row.accountNumber}` : ``, class: (row) => `` },
    {
      field: 'number', title: 'Número', cell: (row) =>
        `${row.number.replace(/\d{4}(?= \d{4})/g, '****')}`, class: (row) => ``
    },
    {
      field: 'account', title: 'Cuenta asociada', cell: (row) => `${row.bank} / ${row.iban}`,
      class: (row) => ``
    },
    { field: 'expiring', title: 'Caducidad', cell: (row) => `${row.monthExpiring} / ${row.yearExpiring}`, class: (row) => `` },
  ];
}

export class TarjetaDebitoConst {
  public static headerTable = [
    {
      field: 'number', title: 'Número', cell: (row) =>
        `${row.number.replace(/\d{4}(?= \d{4})/g, '****')}`, class: (row) => ``
    },
    {
      field: 'account', title: 'Cuenta asociada', cell: (row) => `${row.bank} / ${row.iban}`,
      class: (row) => ``
    },
    { field: 'expiring', title: 'Caducidad', cell: (row) => `${row.monthExpiring} / ${row.yearExpiring}`, class: (row) => `` },
  ];
}
